"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HamburguerMenu = require("./HamburguerMenu");

var _HamburguerMenu2 = _interopRequireDefault(_HamburguerMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HamburguerMenu2.default;